import {nl2br} from './nl2br';

export function mdl(str, {links = false} = {}) {
    if (links) {
        str = str.replace(/\[(.+?)\]\((.+?)\)/gm, '<a href="$2">$1</a>');
    }

    // Note: in the following lines, [\s\S] is used as "catch all" class,
    // to compensate for the fact that JS Regexp have no "dot all" flag
    return (
        str &&
        nl2br(
            str
                // bold
                .replace(/(^|[\s])\*\*([^\s]([\s\S]*?)[^\s])\*\*([\s]|$)/gm, '$1<strong>$2</strong>$4')
                .replace(/(^|[\s])__([^\s]([\s\S]*?)[^\s])__([\s]|$)/gm, '$1<strong>$2</strong>$4')

                // emphasis
                .replace(/(^|[\s])\*([^\s]([\s\S]*?)[^\s])\*([\s]|$)/gm, '$1<em>$2</em>$4')
                .replace(/(^|[\s])_([^\s]([\s\S]*?)[^\s])_([\s]|$)/gm, '$1<em>$2</em>$4')

                // asterisks to list
                .replace(/^ {0,3}\*[ \t](.+?)(\r?\n|$)/gm, '<li>$1</li>')
                .replace(/(<li>.+<\/li>)/gim, '<ul>$1</ul>'),
        )
    );
}
